/**
 * Ray's Loyalty — Personal Center My Assets (coupons, gift cards, claimed records).
 */
(function () {
  'use strict';

  var cacheBySection = Object.create(null);
  var storeCreditCacheBySection = Object.create(null);

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escAttr(s) {
    return esc(s).replace(/'/g, '&#39;');
  }

  function formatPointsMsg(template, points) {
    return String(template || '').split('[points]').join(String(points));
  }

  function formatDate(iso, locale) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return String(iso);
    try {
      return d.toLocaleString(locale || 'en', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      return d.toLocaleString('en', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }

  function discountHeadline(d, S, locale, currencyCode) {
    if (!d || !d.kind) return '';
    if (d.kind === 'percent' && d.value != null) return esc(d.value) + '% OFF';
    if (d.kind === 'fixed' && d.amountCents != null) {
      var currency = d.currencyCode || currencyCode;
      var amount = (d.amountCents / 100).toFixed(2);
      if (currency) {
        try { amount = new Intl.NumberFormat(locale || 'en', { style: 'currency', currency: currency }).format(d.amountCents / 100); }
        catch (e) { amount = currency + ' ' + amount; }
      }
      return esc(amount) + ' OFF';
    }
    if (d.kind === 'free_product') return esc(S.freeProduct || 'Free product');
    if (d.kind === 'bxgy') return esc(S.buyGet || 'Buy & get');
    if (d.kind === 'free_shipping') return esc(S.freeShipping || 'Free shipping');
    if (d.kind === 'gift_card') return esc(S.giftCard || 'Gift card');
    return esc(S.discount || 'Discount');
  }

  function isFreeProductCoupon(c) {
    return c.rewardKind === 'free_product_discount' || (c.discount && c.discount.kind === 'free_product');
  }

  function freeProductTarget(c) {
    var action = c.freeProductCart || {};
    if (!action.productPath) return '';
    try {
      var target = new URL(String(action.productPath), window.location.origin);
      if (target.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(target.pathname)) return '';
      target.search = '';
      target.hash = '';
      if (/^\d+$/.test(String(action.variantId || ''))) target.searchParams.set('variant', String(action.variantId));
      return target.pathname + target.search;
    } catch (e) { return ''; }
  }

  function couponRatioHeadline(c, cfg) {
    if (isFreeProductCoupon(c)) return esc(cfg.S.freeProduct || 'Free product');
    var kind = c.discount && c.discount.kind;
    if (!kind || kind === 'unknown') return esc(c.title || cfg.S.discount || 'Discount');
    return discountHeadline(c.discount, cfg.S, cfg.locale, cfg.currencyCode);
  }

  function couponBucket(c) {
    var st = String(c.status || '').toLowerCase();
    if (st === 'used' || st === 'redeemed' || st === 'consumed') return 'used';
    var usage = c.usage || {};
    if (usage.scope !== 'global' && c.source !== 'shopify_customer' && usage.limit != null && usage.used != null && usage.used >= usage.limit) return 'used';
    var end = c.window && c.window.endsAt ? new Date(c.window.endsAt).getTime() : null;
    if (end != null && !isNaN(end) && end <= Date.now()) return 'expired';
    if (usage.scope === 'global' && usage.limit != null && usage.used != null && usage.used >= usage.limit) return 'expired';
    if (st && st !== 'issued' && st !== 'active' && st !== 'scheduled') return 'expired';
    var start = c.window && c.window.startsAt ? new Date(c.window.startsAt).getTime() : null;
    if (st === 'scheduled' || (start != null && start > Date.now())) return 'scheduled';
    return 'available';
  }

  function couponSourceLabel(c, S) {
    if (c.source === 'app_public') return S.sourcePublic;
    if (c.source === 'monthly_vip') return S.sourceMonthly;
    if (c.source === 'redemption') return S.sourceRedemption;
    return S.sourcePersonal;
  }

  function couponDate(iso, cfg) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', timeZoneName: 'short' };
    if (cfg.timeZone) options.timeZone = cfg.timeZone;
    try { return d.toLocaleString(cfg.locale || 'en', options); }
    catch (e) { return d.toISOString().replace('T', ' ').slice(0, 16) + ' UTC'; }
  }

  function isExpiringSoon(c, days) {
    if (couponBucket(c) !== 'available') return false;
    days = days || 7;
    var end = c.window && c.window.endsAt ? new Date(c.window.endsAt).getTime() : null;
    if (end == null || isNaN(end)) return false;
    var now = Date.now();
    return end > now && end - now <= days * 86400000;
  }

  function isGiftCard(c) {
    return !!(c && c.discount && c.discount.kind === 'gift_card');
  }

  function dottedSeparators(count) {
    var n = count || 40;
    var s = '';
    for (var i = 0; i < n; i++) s += '<span class="discount-dividing__dotted-line__separator"></span>';
    return s;
  }

  /** VIP / Rays Loyalty issued personal coupons (not storewide app_public). */
  function isVipSystemCoupon(c) {
    if (!c) return false;
    var src = String(c.source || '');
    if (src === 'app_public') return false;
    if (src === 'monthly_vip') return true;
    return false;
  }

  function renderDiscountCard(c, cfg, inactive) {
    var code = c.code ? String(c.code) : '';
    var productTarget = isFreeProductCoupon(c) ? freeProductTarget(c) : '';
    var ratio = couponRatioHeadline(c, cfg);
    var bucket = couponBucket(c);
    inactive = inactive || bucket !== 'available';
    var S = cfg.S;
    var exhausted = c.usage && c.usage.scope === 'global' && c.usage.limit != null && c.usage.used != null && c.usage.used >= c.usage.limit;
    var badge = bucket === 'used' ? S.statusUsed : bucket === 'scheduled' ? S.scheduled : bucket === 'expired' ? ((exhausted || /^(revoked|exhausted|disabled)$/i.test(String(c.status || ''))) ? S.unavailable : S.statusExpired) : isExpiringSoon(c) ? S.expiringSoon : '';
    var sourceLabel = couponSourceLabel(c, S);
    var rules = [];
    var scope = isFreeProductCoupon(c) ? (S.freeProductTerms || 'Only the specified reward product is eligible. Other products are not included.') : c.appliesTo === 'order_all' ? S.scopeAll : c.appliesTo === 'products' ? S.scopeProducts : c.appliesTo === 'collections' ? S.scopeCollections : '';
    if (scope) rules.push(esc(scope));
    if (c.description) rules.push(esc(c.description));
    if (c.terms) rules.push(esc(c.terms));
    if (isFreeProductCoupon(c) && !productTarget) rules.push(esc(S.productUnavailable));
    var start = c.window && c.window.startsAt;
    var end = c.window && c.window.endsAt;
    if (start && bucket === 'scheduled') rules.push(esc((S.validFrom || 'Available from') + ' ' + couponDate(start, cfg)));
    if (end) rules.push(esc((S.validUntil || 'Valid until') + ' ' + couponDate(end, cfg)));
    else rules.push(esc(S.noExpiry || 'No expiry date specified'));
    var isVip = isVipSystemCoupon(c);
    var cardClass = 'discount-card rl-discount-card';
    if (inactive) cardClass += ' unavailable';
    if (isVip) cardClass += ' discount-card--vip';
    var h = '<article class="' + cardClass + '">';
    h += '<div class="discount-card__top">';
    h += '<span class="discount-card__notch discount-card__notch--left" aria-hidden="true"></span>';
    h += '<span class="discount-card__notch discount-card__notch--right" aria-hidden="true"></span>';
    h += '<div class="discount-card__contaier">';
    if (sourceLabel || badge) h += '<div class="rl-coupon-meta">' + (sourceLabel ? '<span class="rl-coupon-source">' + esc(sourceLabel) + '</span>' : '') + (badge ? '<span class="rl-coupon-status">' + esc(badge) + '</span>' : '') + '</div>';
    h += '<div class="discount-card__ratio">' + ratio + '</div>';
    if (c.title && esc(c.title) !== ratio) h += '<div class="rl-coupon-title">' + esc(c.title) + '</div>';
    if (c.subtitle) h += '<div class="discount-card__threshold">' + esc(c.subtitle) + '</div>';
    if (code) {
      h += '<div class="discount-card__code">' + esc(cfg.S.codeLabel) + ' <span class="discount-card__code__value">' + esc(code) + '</span></div>';
    }
    h += '</div>';
    if (isVip && cfg.couponVipBadgeUrl) {
      h += '<img class="discount-card__vip" src="' + escAttr(cfg.couponVipBadgeUrl) + '" alt="VIP" width="56" height="56" loading="lazy" decoding="async" />';
    }
    h += '<div class="discount-dividing" aria-hidden="true">';
    h += '<div class="discount-dividing__dotted-line">' + dottedSeparators(40) + '</div>';
    h += '</div>';
    h += '</div>';
    h += '<div class="discount-card__rule">';
    h += '<div class="discount-card__rule__value">';
    rules.forEach(function (line) { h += '<div class="rule-text">' + line + '</div>'; });
    h += '</div>';
    if (code && !inactive) {
      if (productTarget) {
        h += '<button type="button" class="discount-card__rule__copy-button" data-rl-pc-redeem="' + escAttr(code) + '" data-rl-pc-product="' + escAttr(productTarget) + '">' + esc(S.copyRedeem || 'Copy & redeem') + '</button>';
      } else {
        h += '<button type="button" class="discount-card__rule__copy-button" data-rl-pc-copy="' + escAttr(code) + '">' + esc(cfg.S.copy) + '</button>';
      }
    }
    h += '</div></article>';
    return h;
  }


  function renderRecordCard(item, cfg) {
    var inactive = !item.active || !!item.statusBadge;
    var h = '<li class="rays-loyalty-records__card' + (inactive ? ' is-inactive' : '') + '">';
    h += '<div class="rays-loyalty-records__card-top">';
    if (item.imageUrl) {
      h += '<img class="rays-loyalty-records__card-img" src="' + escAttr(item.imageUrl) + '" alt="" loading="lazy" />';
    } else {
      h += '<div class="rays-loyalty-records__card-img rays-loyalty-records__card-img--empty" aria-hidden="true"></div>';
    }
    h += '<div class="rays-loyalty-records__card-code">';
    if (item.code) {
      h += '<p class="rays-loyalty-records__code-line">' + esc(cfg.S.codeLabel) + ' <span>' + esc(item.code) + '</span></p>';
      if (item.active) {
        h += '<button type="button" class="rays-loyalty-records__copy" data-rl-pc-copy="' + escAttr(item.code) + '">' + esc(cfg.S.copy) + '</button>';
      } else if (item.statusBadge) {
        h += '<span class="rays-loyalty-records__badge">' + esc(item.statusBadge) + '</span>';
      }
    } else if (item.kind === 'redeem') {
      h += '<p class="rays-loyalty-records__code-line rays-loyalty-records__code-line--muted">' + esc(cfg.S.storeCredit) + '</p>';
    }
    h += '</div></div><div class="rays-loyalty-records__card-meta">';
    h += '<p class="rays-loyalty-records__card-title">' + esc(item.title) + '</p>';
    if (item.discountLine) h += '<p class="rays-loyalty-records__card-discount">' + item.discountLine + '</p>';
    if (item.description) h += '<p class="rays-loyalty-records__card-desc">' + esc(item.description) + '</p>';
    if (item.dateLabel) {
      h += '<p class="rays-loyalty-records__card-time"><span aria-hidden="true"></span>' + esc(cfg.S.effective) + ' ' + esc(item.dateLabel) + '</p>';
    }
    h += '</div></li>';
    return h;
  }

  function buildClaimedItems(couponsPayload, ledgerEntries, rewards, cfg) {
    var items = [];
    var personal = (couponsPayload && couponsPayload.personal) || [];
    var rewardImageByHandle = Object.create(null);
    (rewards || []).forEach(function (rw) {
      if (rw && rw.handle) rewardImageByHandle[rw.handle] = rw.imageUrl || '';
    });
    personal.forEach(function (c) {
      if (c.source !== 'redemption') return;
      var img = (c.spendRuleHandle && rewardImageByHandle[c.spendRuleHandle]) || cfg.defaultImage || '';
      var active = couponBucket(c) === 'available';
      var badge = active ? '' : couponBucket(c) === 'used' ? cfg.S.statusUsed : cfg.S.statusExpired;
      items.push({
        kind: 'coupon',
        title: c.title || cfg.S.redemption,
        code: c.code || null,
        imageUrl: img,
        discountLine: discountHeadline(c.discount, cfg.S),
        description: c.description || '',
        dateLabel: formatDate(c.window && c.window.startsAt, cfg.locale),
        active: active,
        statusBadge: badge,
        sortAt: (c.window && c.window.startsAt) || ''
      });
    });
    (ledgerEntries || []).forEach(function (e) {
      var r = String(e.reason || '').toLowerCase();
      if (r.indexOf('redeem') === -1) return;
      var delta = Number(e.delta) || 0;
      if (delta >= 0) return;
      var day = e.createdAt ? String(e.createdAt).slice(0, 10) : '';
      var dup = personal.some(function (c) {
        if (!c.code) return false;
        var t = (c.window && c.window.startsAt) || '';
        return day && t && String(t).slice(0, 10) === day;
      });
      if (dup) return;
      items.push({
        kind: 'redeem',
        title: cfg.S.redemption,
        code: null,
        imageUrl: cfg.defaultImage || '',
        discountLine: esc(cfg.S.storeCredit),
        description: formatPointsMsg(cfg.S.pointsSpent, Math.abs(delta)),
        dateLabel: formatDate(e.createdAt, cfg.locale),
        active: true,
        statusBadge: '',
        sortAt: e.createdAt || ''
      });
    });
    items.sort(function (a, b) {
      return new Date(b.sortAt).getTime() - new Date(a.sortAt).getTime();
    });
    return items;
  }

  function bindCopy(root, toastEl, copiedLabel, failedLabel) {
    if (!root) return;
    root.querySelectorAll('[data-rl-pc-copy]').forEach(function (btn) {
      if (btn.dataset.rlCopyBound) return;
      btn.dataset.rlCopyBound = '1';
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-rl-pc-copy') || '';
        var done = function (label) {
          if (toastEl) {
            toastEl.textContent = label;
            toastEl.hidden = false;
            window.setTimeout(function () { toastEl.hidden = true; }, 1600);
          }
        };
        Promise.resolve().then(function () {
          if (window.RaysLoyalty && window.RaysLoyalty.copyToClipboard) return window.RaysLoyalty.copyToClipboard(code);
          if (navigator.clipboard) return navigator.clipboard.writeText(code);
          throw new Error('clipboard_unavailable');
        }).then(function () { done(copiedLabel); }).catch(function () { done(failedLabel || 'Could not copy. Please select and copy the code.'); });
      });
    });
  }

  function bindProductRedeem(root, toastEl, cfg) {
    root.querySelectorAll('[data-rl-pc-redeem]').forEach(function (btn) {
      if (btn.dataset.rlRedeemBound) return;
      btn.dataset.rlRedeemBound = '1';
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var code = btn.getAttribute('data-rl-pc-redeem') || '';
        var path = freeProductTarget({ freeProductCart: { productPath: btn.getAttribute('data-rl-pc-product') } });
        // Revalidate the page path, retaining only the known numeric variant.
        var original = new URL(btn.getAttribute('data-rl-pc-product') || '', window.location.origin);
        var variant = original.searchParams.get('variant');
        if (path && /^\d+$/.test(variant || '')) path += '?variant=' + encodeURIComponent(variant);
        if (!code || !path) return;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        var proceed = function () {
          window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(path));
        };
        Promise.resolve().then(function () {
          if (window.RaysLoyalty && window.RaysLoyalty.copyToClipboard) return window.RaysLoyalty.copyToClipboard(code);
          if (navigator.clipboard) return navigator.clipboard.writeText(code);
          throw new Error('clipboard_unavailable');
        }).then(proceed).catch(function () {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          if (toastEl) { toastEl.textContent = cfg.S.copyFailed; toastEl.hidden = false; }
          var card = btn.closest('article');
          var fallback = card && card.querySelector('[data-rl-pc-continue]');
          if (!fallback && card) {
            fallback = document.createElement('a');
            fallback.setAttribute('data-rl-pc-continue', '');
            fallback.className = 'rl-coupon-continue';
            fallback.textContent = cfg.S.continueRedeem || 'Apply & view product';
            fallback.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(path);
            card.appendChild(fallback);
          }
        });
      });
    });
  }

  function readConfig(sectionId) {
    var el = document.getElementById('rl-pc-assets-config-' + sectionId);
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  function waitForRL(maxMs) {
    maxMs = maxMs != null ? maxMs : 8000;
    var started = Date.now();
    return new Promise(function (resolve) {
      function tick() {
        if (window.RaysLoyalty && window.RaysLoyalty.getCoupons) return resolve(true);
        if (Date.now() - started > maxMs) return resolve(false);
        window.setTimeout(tick, 40);
      }
      tick();
    });
  }

  function loadData(cfg) {
    if (cacheBySection[cfg.sectionId]) return Promise.resolve(cacheBySection[cfg.sectionId]);
    return Promise.all([
      window.RaysLoyalty.getCoupons({ includeHistory: true }).then(function (payload) {
        if (!payload || !Array.isArray(payload.personal) || !Array.isArray(payload.universal)) throw new Error('invalid_coupon_response');
        return payload;
      }).catch(function () { return { failed: true, personal: [], universal: [] }; }),
      window.RaysLoyalty.getLedger().catch(function () { return { entries: [] }; }),
      window.RaysLoyalty.getRewards().catch(function () { return { rewards: [] }; })
    ]).then(function (res) {
      var data = { coupons: res[0], ledger: res[1], rewards: res[2] };
      if (!res[0].failed) cacheBySection[cfg.sectionId] = data;
      return data;
    });
  }

  function renderCoupons(cfg) {
    var root = document.getElementById('rl-pc-coupon-' + cfg.sectionId);
    if (!root) return;
    var listEl = document.getElementById('rl-pc-coupon-list-' + cfg.sectionId);
    var emptyEl = document.getElementById('rl-pc-coupon-empty-' + cfg.sectionId);
    var loadingEl = document.getElementById('rl-pc-coupon-loading-' + cfg.sectionId);
    var toastEl = document.getElementById('rl-pc-coupon-toast-' + cfg.sectionId);
    var status = root.dataset.couponStatus || 'available';
    var filter = root.dataset.couponFilter || 'all';
    root.dataset.renderRequest = String((Number(root.dataset.renderRequest) || 0) + 1);
    var request = root.dataset.renderRequest;
    if (loadingEl) loadingEl.hidden = false;
    return loadData(cfg).then(function (data) {
      if (root.dataset.renderRequest !== request) return;
      var errorEl = document.getElementById('rl-pc-coupon-error-' + cfg.sectionId);
      if (errorEl) errorEl.hidden = !data.coupons.failed;
      if (data.coupons.failed) {
        if (loadingEl) loadingEl.hidden = true;
        if (listEl) { listEl.hidden = true; listEl.innerHTML = ''; }
        if (emptyEl) emptyEl.hidden = true;
        root.hidden = false;
        return;
      }
      var guest = data.coupons.authenticated === false;
      var loginEl = document.getElementById('rl-pc-coupon-login-' + cfg.sectionId);
      var toolbar = root.querySelector('.rl-pc-coupon__toolbar');
      if (loginEl) loginEl.hidden = !guest;
      if (toolbar) toolbar.hidden = guest;
      if (guest) {
        if (loadingEl) loadingEl.hidden = true;
        if (listEl) { listEl.hidden = true; listEl.innerHTML = ''; }
        if (emptyEl) emptyEl.hidden = true;
        root.hidden = false;
        return;
      }
      var all = ((data.coupons && data.coupons.personal) || []).concat((data.coupons && data.coupons.universal) || []);
      var cards = all.filter(function (c) { return !isGiftCard(c); });
      cards = cards.filter(function (c) { var bucket = couponBucket(c); return bucket === status || (status === 'available' && bucket === 'scheduled'); });
      cards.sort(function (a, b) { var scheduled = Number(couponBucket(a) === 'scheduled') - Number(couponBucket(b) === 'scheduled'); return scheduled || (Date.parse(a.window && a.window.endsAt) || Infinity) - (Date.parse(b.window && b.window.endsAt) || Infinity); });
      if (filter === 'expiring') cards = cards.filter(function (c) { return isExpiringSoon(c); });
      if (loadingEl) loadingEl.hidden = true;
      root.hidden = false;
      if (!cards.length) {
        if (listEl) { listEl.hidden = true; listEl.innerHTML = ''; }
        if (emptyEl) { emptyEl.hidden = false; var emptyText = emptyEl.querySelector('p'); if (emptyText) emptyText.textContent = filter === 'expiring' ? cfg.S.emptyExpiring : status === 'used' ? cfg.S.emptyUsed : status === 'expired' ? cfg.S.emptyExpired : cfg.S.emptyAvailable; }
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      if (listEl) {
        listEl.hidden = false;
        listEl.innerHTML = cards.map(function (c) {
          return renderDiscountCard(c, cfg, status !== 'available');
        }).join('');
        bindCopy(listEl, toastEl, cfg.S.copied, cfg.S.copyFailed);
        bindProductRedeem(listEl, toastEl, cfg);
      }
    });
  }

  function renderGiftCards(cfg) {
    var root = document.getElementById('rl-pc-giftcard-' + cfg.sectionId);
    if (!root) return;
    var panel = root.querySelector('.rl-pc-giftcard__panel.is-active, .rl-pc-giftcard__panel[data-giftcard-status="' + (root.dataset.giftcardStatus || 'available') + '"]');
    if (!panel) panel = root.querySelector('.rl-pc-giftcard__panel');
    var listEl = panel && panel.querySelector('.rl-pc-giftcard__list');
    var emptyEl = panel && panel.querySelector('.rl-pc-giftcard__empty');
    var loadingEl = panel && panel.querySelector('.rl-pc-giftcard__loading');
    var toastEl = root.querySelector('.rl-pc-giftcard__toast');
    var status = root.dataset.giftcardStatus || 'available';
    var filter = root.dataset.giftcardFilter || 'all';
    return loadData(cfg).then(function (data) {
      var cards = ((data.coupons && data.coupons.personal) || []).filter(isGiftCard);
      cards = cards.filter(function (c) { return couponBucket(c) === status; });
      if (filter === 'expiring') cards = cards.filter(function (c) { return isExpiringSoon(c); });
      if (loadingEl) loadingEl.hidden = true;
      root.hidden = false;
      if (!cards.length) {
        if (listEl) { listEl.innerHTML = ''; }
        if (emptyEl) emptyEl.hidden = false;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      if (listEl) {
        listEl.innerHTML = cards.map(function (c) {
          return renderDiscountCard(c, cfg, status !== 'available');
        }).join('');
        bindCopy(listEl, toastEl, cfg.S.copied, cfg.S.copyFailed);
      }
    });
  }

  function renderClaimed(cfg) {
    var el = document.getElementById('rl-pc-rew-cl-' + cfg.sectionId);
    if (!el) return Promise.resolve();
    return loadData(cfg).then(function (data) {
      var items = buildClaimedItems(data.coupons, (data.ledger && data.ledger.entries) || [], (data.rewards && data.rewards.rewards) || [], cfg);
      if (!items.length) {
        el.innerHTML = '<p class="rl-pc-empty">' + esc(cfg.S.claimedEmpty) + '</p>';
        if (cfg.recordsUrl) {
          el.innerHTML += '<p class="rl-pc-records-link-wrap"><a class="rl-pc-records-link" href="' + escAttr(cfg.recordsUrl) + '">' + esc(cfg.S.viewRecords) + '</a></p>';
        }
        return;
      }
      var html = '<ul class="rays-loyalty-records__grid rl-pc-records-embed__grid">';
      items.forEach(function (it) { html += renderRecordCard(it, cfg); });
      html += '</ul>';
      if (cfg.recordsUrl) {
        html += '<p class="rl-pc-records-link-wrap"><a class="rl-pc-records-link" href="' + escAttr(cfg.recordsUrl) + '">' + esc(cfg.S.viewRecords) + '</a></p>';
      }
      el.innerHTML = html;
      bindCopy(el, null, cfg.S.copied);
    });
  }

  function syncCouponUrl(root) {
    if (!root || !window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      var mod = (url.searchParams.get('module') || '').toLowerCase();
      if (mod && mod !== 'coupon' && mod !== 'coupons') return;
      var status = root.dataset.couponStatus || 'available';
      var filter = root.dataset.couponFilter || 'all';
      url.searchParams.set('module', 'coupon');
      if (status === 'available') url.searchParams.delete('coupon_status');
      else url.searchParams.set('coupon_status', status);
      if (filter === 'all') url.searchParams.delete('coupon_filter');
      else url.searchParams.set('coupon_filter', filter);
      history.replaceState(null, '', url.pathname + url.search + url.hash);
    } catch (e) {}
  }

  function wireCouponPanel(cfg) {
    var root = document.getElementById('rl-pc-coupon-' + cfg.sectionId);
    if (!root || root.dataset.rlPcBound) return;
    root.dataset.rlPcBound = '1';
    var retry = root.querySelector('[data-rl-coupon-retry]');
    if (retry) retry.addEventListener('click', function () { delete cacheBySection[cfg.sectionId]; renderCoupons(cfg); });
    root.querySelectorAll('[data-coupon-status]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-coupon-status]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        root.dataset.couponStatus = btn.getAttribute('data-coupon-status');
        syncCouponUrl(root);
        renderCoupons(cfg);
      });
    });
    root.querySelectorAll('[data-coupon-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-coupon-filter]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        root.dataset.couponFilter = btn.getAttribute('data-coupon-filter');
        syncCouponUrl(root);
        renderCoupons(cfg);
      });
    });
  }

  function txLabel(kind, S) {
    if (kind === 'credit') return S.storeCreditCredit || 'Credit';
    if (kind === 'debit') return S.storeCreditDebit || 'Debit';
    return S.storeCreditOther || 'Transaction';
  }

  function renderStoreCredits(cfg, cachedPayload) {
    var root = document.getElementById('rl-pc-store-credit-' + cfg.sectionId);
    if (!root) return Promise.resolve();
    var balanceEl = root.querySelector('[data-rl-pc-store-credit-balance]');
    var listEl = root.querySelector('[data-rl-pc-store-credit-list]');
    var emptyEl = root.querySelector('.rl-pc-store-credit__empty');
    var loadingEl = root.querySelector('.rl-pc-store-credit__loading');

    function paint(payload) {
      var formatted = '—';
      if (payload && !payload.error) {
        if (payload.formatted != null && String(payload.formatted).trim() !== '') {
          formatted = String(payload.formatted);
        } else if (payload.balanceCents != null && payload.currencyCode) {
          try {
            formatted = new Intl.NumberFormat(cfg.locale || 'en', {
              style: 'currency',
              currency: String(payload.currencyCode)
            }).format(Number(payload.balanceCents) / 100);
          } catch (_e) {
            formatted =
              String(payload.currencyCode) +
              ' ' +
              (Number(payload.balanceCents) / 100).toFixed(2);
          }
        }
      }
      if (balanceEl) balanceEl.textContent = formatted;
      var txs = (payload && payload.transactions) || [];
      if (loadingEl) loadingEl.hidden = true;
      root.hidden = false;
      if (!txs.length) {
        if (listEl) listEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      if (!listEl) return;
      listEl.innerHTML = txs
        .map(function (tx) {
          var kind = tx.kind || 'other';
          var signed =
            tx.amountCents != null
              ? Number(tx.amountCents)
              : 0;
          var prefix = signed > 0 ? '+' : signed < 0 ? '−' : '';
          var amtClass =
            signed > 0
              ? 'rl-pc-store-credit__tx-amount--credit'
              : signed < 0
                ? 'rl-pc-store-credit__tx-amount--debit'
                : '';
          var displayAmt =
            tx.formattedAmount != null
              ? String(tx.formattedAmount)
              : String(Math.abs(signed) / 100);
          var rowLabel =
            tx.label && String(tx.label).trim()
              ? String(tx.label)
              : txLabel(kind, cfg.S);
          return (
            '<li class="rl-pc-store-credit__tx rl-pc-store-credit__tx--' +
            esc(kind) +
            '">' +
            '<div class="rl-pc-store-credit__tx-meta">' +
            '<p class="rl-pc-store-credit__tx-label">' +
            esc(rowLabel) +
            '</p>' +
            '<p class="rl-pc-store-credit__tx-date">' +
            esc(formatDate(tx.createdAt, cfg.locale)) +
            '</p></div>' +
            '<span class="rl-pc-store-credit__tx-amount ' +
            amtClass +
            '">' +
            esc(prefix + displayAmt) +
            '</span></li>'
          );
        })
        .join('');
    }

    if (cachedPayload) {
      paint(cachedPayload);
      return Promise.resolve(cachedPayload);
    }

    var cached = storeCreditCacheBySection[cfg.sectionId];
    if (cached) {
      paint(cached);
      return Promise.resolve(cached);
    }

    if (!window.RaysLoyalty || !window.RaysLoyalty.getStoreCredit) {
      if (loadingEl) loadingEl.hidden = true;
      paint(null);
      return Promise.resolve(null);
    }

    return window.RaysLoyalty.getStoreCredit({ locale: cfg.locale })
      .then(function (payload) {
        storeCreditCacheBySection[cfg.sectionId] = payload || {};
        paint(payload);
        return payload;
      })
      .catch(function () {
        if (loadingEl) loadingEl.hidden = true;
        paint(null);
        return null;
      });
  }

  function wireGiftCardPanel(cfg) {
    var root = document.getElementById('rl-pc-giftcard-' + cfg.sectionId);
    if (!root || root.dataset.rlPcBound) return;
    root.dataset.rlPcBound = '1';
    root.querySelectorAll('[data-giftcard-status]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-giftcard-status]').forEach(function (b) {
          b.classList.toggle('active', b === btn);
          b.classList.toggle('AvailableBot', b === btn);
        });
        root.dataset.giftcardStatus = btn.getAttribute('data-giftcard-status');
        renderGiftCards(cfg);
      });
    });
    root.querySelectorAll('[data-giftcard-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-giftcard-filter]').forEach(function (b) {
          b.classList.toggle('active', b === btn);
        });
        root.dataset.giftcardFilter = btn.getAttribute('data-giftcard-filter');
        renderGiftCards(cfg);
      });
    });
  }

  function init(sectionId) {
    var cfg = readConfig(sectionId);
    if (!cfg) return Promise.resolve();
    cfg.sectionId = sectionId;
    return waitForRL().then(function (ok) {
      if (!ok || !window.RaysLoyalty) return;
      if (window.RaysLoyalty.syncStorefrontTokenFromWebComponents) {
        try { window.RaysLoyalty.syncStorefrontTokenFromWebComponents(); } catch (e) {}
      }
      wireCouponPanel(cfg);
      wireGiftCardPanel(cfg);
      return Promise.all([
        renderCoupons(cfg),
        renderGiftCards(cfg),
        renderStoreCredits(cfg)
      ]);
    });
  }

  function refresh(sectionId) {
    delete cacheBySection[sectionId];
    delete storeCreditCacheBySection[sectionId];
    return init(sectionId);
  }

  window.RlPcAssets = {
    init: init,
    refresh: refresh,
    renderClaimed: renderClaimed,
    setStoreCreditCache: function (sectionId, payload) {
      storeCreditCacheBySection[sectionId] = payload || {};
      var cfg = readConfig(sectionId);
      if (!cfg) return Promise.resolve();
      cfg.sectionId = sectionId;
      return renderStoreCredits(cfg, payload);
    },
    renderStoreCredits: function (sectionId) {
      var cfg = readConfig(sectionId);
      if (!cfg) return Promise.resolve();
      cfg.sectionId = sectionId;
      return renderStoreCredits(cfg);
    },
    renderCoupons: function (sectionId) {
      var cfg = readConfig(sectionId);
      if (!cfg) return Promise.resolve();
      cfg.sectionId = sectionId;
      return renderCoupons(cfg);
    }
  };
})();
